import { useValidDealerContext } from "../context/DealerProviderContext.tsx";

export const Logo = ({ className }: { className?: string }) => {
  const {
    organisationData: { name, profileImageUrl, companyLogoUrl },
  } = useValidDealerContext();
  const url = companyLogoUrl || profileImageUrl;
  if (!url) {
    return null;
  }

  return (
    <img src={url} alt={`${name} logo`} className={`max-w-[160] max-h-[40] rounded-2 ${className ? className : ""}`} />
  );
};
